module.exports = __webpack_public_path__ + "static/media/letter-profile.bbe185f5.jpg";